import type { RouteLocationRaw } from 'vue-router';
import { HOMOLOGATION_RECORD_SEGMENT } from '@/shared/lib';
import type { NoticeNavigationTarget } from './types';

interface NavigableNotice {
  eventType: string;
  navigationTarget: NoticeNavigationTarget | null;
  navigationEntityId: number | null;
}

// A rejected revision leaves homologation, so its notice has nothing left to open. The filter is by
// event type, not by target, so notices already stored with a target lose the link too.
const UNLINKED_EVENT_TYPES: ReadonlySet<string> = new Set([
  'document.failed_approval',
  'document.failed_verification',
  'record.failed_approval',
  'record.failed_verification',
]);

type NavigationResolver = (notice: NavigableNotice) => RouteLocationRaw | null;

const ROUTE_BY_TARGET: Record<NoticeNavigationTarget, NavigationResolver> = {
  APPROVAL: (notice) =>
    typeof notice.navigationEntityId === 'number'
      ? `/aprovacao/${notice.navigationEntityId}`
      : null,
  VERIFICATION: (notice) =>
    typeof notice.navigationEntityId === 'number'
      ? `/verificacao/${notice.navigationEntityId}`
      : null,
  // O Registro tem rota propria: o mesmo id existe em revisao de documento e em matriz.
  RECORD_APPROVAL: (notice) =>
    typeof notice.navigationEntityId === 'number'
      ? `/aprovacao/${HOMOLOGATION_RECORD_SEGMENT}/${notice.navigationEntityId}`
      : null,
  RECORD_VERIFICATION: (notice) =>
    typeof notice.navigationEntityId === 'number'
      ? `/verificacao/${HOMOLOGATION_RECORD_SEGMENT}/${notice.navigationEntityId}`
      : null,
  HOMOLOGATION: (notice) =>
    typeof notice.navigationEntityId === 'number'
      ? `/homologacao?revisionId=${notice.navigationEntityId}`
      : '/homologacao',
  RECORD_HOMOLOGATION: (notice) =>
    typeof notice.navigationEntityId === 'number'
      ? `/homologacao?matrixId=${notice.navigationEntityId}`
      : '/homologacao',
  TRAINING: () => '/treinamentos',
  HOME: () => '/',
};

export const getNoticeNavigationTarget = (notice: NavigableNotice): RouteLocationRaw | null => {
  if (!notice.navigationTarget || UNLINKED_EVENT_TYPES.has(notice.eventType)) {
    return null;
  }

  const resolver = ROUTE_BY_TARGET[notice.navigationTarget];
  if (!resolver) {
    return null;
  }

  return resolver(notice);
};
